import EyeDrawSection from '../EyeDrawSection';
import thumb20 from '../images/thumb_20.jpg';
import thumb21 from '../images/thumb_21.jpg';
import thumb22 from '../images/thumb_22.jpg';
import thumb23 from '../images/thumb_23.jpg';
import img20 from '../images/20.png';
import img21 from '../images/21.png';
import img22 from '../images/22.png';
import img23 from '../images/23.png';

const cards = [
    { title: 'Glaucoma - Progression', thumb: thumb20, image: img20 },
    { title: 'Glaucoma - Open Angle', thumb: thumb21, image: img21 },
    { title: 'Glaucoma - Closed Angle', thumb: thumb22, image: img22 },
    { title: 'Glaucoma - Narrow Angle', thumb: thumb23, image: img23 },
];

export default function Glaucoma() {
    return <EyeDrawSection id="glaucoma" title="Glaucoma" icon="bi-bar-chart" cards={cards} />;
}
